enum UserTypes {
    SHOW_WEBHID_PAIR_BUTTON = 'SHOW_WEBHID_PAIR_BUTTON',
    HIDE_WEBHID_PAIR_BUTTON = 'HIDE_WEBHID_PAIR_BUTTON',
    SET_WEBHID_IN_CALL = 'SET_WEBHID_IN_CALL',
    SET_IGNORE_DEVICE_SIGNALS = 'SET_IGNORE_DEVICE_SIGNALS',
    SET_CONNECTED_HEADSET = 'SET_CONNECTED_HEADSET'
}

export default UserTypes;